import { render, staticRenderFns, recyclableRender, components } from "./factory_change_personnel.vue?vue&type=template&id=242f2974&scoped=true&"
var renderjs
import script from "./factory_change_personnel.vue?vue&type=script&lang=js&"
export * from "./factory_change_personnel.vue?vue&type=script&lang=js&"
import style0 from "./factory_change_personnel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./factory_change_personnel.vue?vue&type=style&index=1&id=242f2974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f2974",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/factory_change_personnel/factory_change_personnel.vue"
export default component.exports